import AbstractService from 'core/abstracts/AbstractService';
import Facade from 'core/Facade';

class UserService extends AbstractService {

    // USERS CRUD
    getUsers() {
        return this.request({
            method: 'GET',
            url: Facade.getApiRoot() + 'bo/users?ps=1000&p=1&sort=alpha_asc',
        }).then(async (responseData) => {
            if (responseData.ok) {
                return await responseData.json();
            }
            throw await responseData.json();
        });
    }

    getUser(id) {
        return this.request({
            method: 'GET',
            url: Facade.getApiRoot() + 'bo/users/' + id,
        }).then(responseData => {
            if (responseData.ok) {
                return responseData.json();
            }
            throw responseData;
        });
    }

    addUser(options) {
        return this.request({
            method: 'POST',
            url: Facade.getApiRoot() + 'bo/users',
            json: {
                login: options.login,
                account_ids: options.accounts.map(a => a.id),
                first_name: options.firstName,
                last_name: options.lastName,
                max_connection: options.maxConnection,
                settings: {
                    language: options.settings.language,
                    page_size: options.settings.pageSize
                },
                permissions: options.permissions,
                is_blocked: options.isBlocked
            }
        }).then(responseData => {
            if (responseData.ok) {
                return responseData.json();
            }
            throw responseData;
        });
    }

    updateUser(options, id) {
        const updatedUser = {
            login: options.login,
            first_name: options.firstName,
            last_name: options.lastName,
            max_connection: options.maxConnection,
            settings: {
                language: options.settings.language,
                page_size: options.settings.pageSize
            },
            permissions: options.permissions,
            is_blocked: options.isBlocked
        };

        if (!updatedUser.permissions.SuperUser) {
            updatedUser.account_ids = options.accounts.map(a => a.id);
        }

        return this.request({
            method: 'PUT',
            url: Facade.getApiRoot() + 'bo/users/' + id,
            json: updatedUser
        }).then(responseData => {
            if (responseData.ok) {
                return responseData.json();
            }
            throw responseData;
        });
    }

    deleteUser(id) {
        return this.request({
            method: 'DELETE',
            url: Facade.getApiRoot() + 'bo/users/' + id,
        }).then(responseData => {
            if (responseData.ok) {
                return responseData.json();
            }
            throw responseData;
        });
    }

    // USER ACTIONS
    getUserActions(options) {
        return this.request({
            method: 'POST',
            url: Facade.getApiRoot() + `bo/user-action-records?from=${Facade.formatDateForUrl(options.fromStr.$d ? options.fromStr.$d : options.fromStr)}&to=${Facade.formatDateForUrl(options.toStr.$d ? options.toStr.$d : options.toStr)}&ps=${options.pageSize ? options.pageSize : 50}&p=${options.pageIndex ? options.pageIndex : 1}`,
            json: {
                user_ids: options.selectedUsers,
                actions: options.selectedActions,
                account_ids: options.selectedAccounts
            }
        }).then(async (responseData) => {
            if (responseData.ok) {
                return {
                    count: responseData.headers.get('X-Total-Count'),
                    ...await responseData.json()
                };
            }
            throw await responseData.json();
        });
    }

    getUserActionsGraph(options) {
        return this.request({
            method: 'POST',
            url: Facade.getApiRoot() + `bo/user-action-records/analyze?from=${Facade.formatDateForUrl(options.fromStr.$d ? options.fromStr.$d : options.fromStr)}&to=${Facade.formatDateForUrl(options.toStr.$d ? options.toStr.$d : options.toStr)}`,
            json: {
                user_ids: options.users,
                actions: options.actions,
                granularity: options.granularity
            }
        }).then(async (responseData) => {
            if (responseData.ok) {
                return await responseData.json();
            }
            throw await responseData.json();
        });
    }

    getActionsNames() {
        return this.request({
            method: 'GET',
            url: Facade.getApiRoot(),
        }).then(async (response) => {
            if (response.ok) {
                return await response.json();
            }
            throw await response.json();
        });
    }
}

export default new UserService();
